import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorComponent } from '../error/error/error.component';

export const ERROR_ROUTE: Routes = [
  {
    path: 'error',
    component: ErrorComponent, data: {
      authorities: [],
      pageTitle: 'error.title'
    },
  },
  {
    path: 'accessdenied',
    component: ErrorComponent,
    data: {
      authorities: [],
      pageTitle: 'error.title',
      error403: true
    },
  },
  {
    path: 'sessiontimeout',
    component: ErrorComponent,
    data: {
      authorities: [],
      pageTitle: 'error.title',
      errorMessage: 'Session has been timed out'
    },
  },
  {
    path: 'logout',
    component: ErrorComponent,
    data: {
      authorities: [],
      pageTitle: 'error.title',
      errorMessage: 'logout seccess'
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(ERROR_ROUTE)],
  exports: [RouterModule]
})
export class ErrorRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/error/error-routing.module.ts